import React from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaShoppingCart, FaBoxOpen, FaHeart, FaFrown } from 'react-icons/fa';

const iconMap = {
  search: FaSearch,
  cart: FaShoppingCart,
  products: FaBoxOpen,
  favorites: FaHeart,
  default: FaFrown
};

export default function EmptyState({
  title = "No items found",
  description = "There are currently no items to display",
  icon = "default",
  showButton = true,
  buttonText = "Go to Home",
  buttonLink = "/"
}) {
  const IconComponent = iconMap[icon] || iconMap.default;

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 text-gray-400">
        <IconComponent className="text-5xl" />
      </div>
      <h2 className="text-2xl font-semibold text-gray-700 mb-2">{title}</h2>
      <p className="text-gray-500 mb-6 max-w-md">{description}</p>
      {showButton && (
        <Link
          to={buttonLink}
          className="inline-block bg-[#00148c] hover:bg-[#002080] text-white font-medium py-2 px-6 rounded-md transition-colors"
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
}